import { render, staticRenderFns } from "./hutchdutchsettlement.vue?vue&type=template&id=9e34a028&scoped=true"
import script from "./hutchdutchsettlement.vue?vue&type=script&lang=js"
export * from "./hutchdutchsettlement.vue?vue&type=script&lang=js"
import style0 from "./hutchdutchsettlement.vue?vue&type=style&index=0&id=9e34a028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e34a028",
  null
  
)

export default component.exports